import React from "react";
import styled from "styled-components";

const Logo = () => {
  return (
    <LogoContainer>
      <a href="https://phoneboxmobile.com/">
        <img src="/images/phonebox-logo.png" alt="PhoneBox Logo" />
      </a>
    </LogoContainer>
  );
};
const LogoContainer = styled.div`
  position: absolute;
  top: 10px;
  z-index: 10;

  img {
    height: 40px;
    width: auto;
  }

  @media (max-width: 768px) {
    top: 10px;
    left: 10px;
    img {
      height: 32px;
    }
  }
`;

export default Logo;
